import LifepointsModerateStrategyFund from './lifepointsModerateStrategyFund';

export default LifepointsModerateStrategyFund;
